import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {faker} from '@faker-js/faker';
import Typography from '@mui/material/Typography';

export default function PointsDetailDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Typography variant="body1" onClick={handleClickOpen}>
        <b>Creator Points</b>: {faker.number.int({min: 100, max: 1000})}
      </Typography>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Creator Points : {faker.number.int({min: 100, max: 1000})}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            When users interacts more with your question. You'll get more points.
            <Typography variant="body2" onClick={handleClickOpen}>
              <b>How can you earn it?</b>
            </Typography>
            <p>Like - 10 Points </p>
            <p>Create - 1 Points</p>
            <p>Vote/Answer - 5 points</p>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
